var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"compnent",class:{
    button: true,
    'button--primary': _vm.type === 'primary',
    'button--secondary': _vm.type === 'secondary',
    'button--twitter': _vm.type === 'twitter',
    'button--x': _vm.type === 'x',
    'button--answer': _vm.type === 'answer',
    'button--sexualityAction': _vm.type === 'sexualityAction',
    'button--shake': _vm.type === 'shake',
  },attrs:{"type":"button","href":_vm.href},on:{"click":_vm.clickButton}},[(_vm.type === 'twitter')?_c('img',{staticClass:"button__img twitterImg",attrs:{"src":require("assets/img/social/twitter.svg"),"alt":"twitter"}}):_vm._e(),_vm._v(" "),(_vm.type === 'google')?_c('img',{staticClass:"button__img googleImg",attrs:{"src":require("assets/img/social/google.svg"),"alt":"google"}}):_vm._e(),_vm._v(" "),(_vm.type === 'x')?_c('img',{staticClass:"button__img xImg",attrs:{"src":require("assets/img/social/x.svg"),"alt":"x"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"button__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }